import axiosDeqart from 'api/axios';

const postContactUs = async (body) => {
  try {
    const { data } = await axiosDeqart.post('/contact-us', body);
    return data?.data;
  } catch (err) {
    console.log('An error occurred while fetching user data', err.message);
    return err;
  }
};

export default postContactUs;
